String.isNullOrEmpty = function(e) {
  return !e;
};

String.isNullOrWhiteSpace = function(e) {
  if (!e) return true;
  return /^\s*$/.test(e);
};

Object.isNullOrEmpty = function(obj) {
  if (!obj) return true;
  return Object.entries(obj).length === 0;
};

Object.isUndefineOrNull = function(e) {
  if (typeof e == "undefined") return true;
  if (e === null) return true;
  return false;
};

Array.isNullOrEmpty = function(e) {
  return !e || e.length == 0;
};


String.isMobile =function(e){
  if(String.isNullOrEmpty(e)) return false;
  if(e.length!=11) return false;
  return /^1\d{10}$/.test(e)
}